import styled from 'styled-components';
import WhiteLeftSvg from '../../assets/hotels/arrow-left-white.svg';

const WHiteArrowLeft = styled(WhiteLeftSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '5rem'};
  height: ${props => props.height || '5rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default WHiteArrowLeft;
